const IMG = 'https://static.prod-images.emergentagent.com/jobs/f0d195cd-4b3e-4ed9-b8e7-ef79e8727f8c/images';

export const HERO_IMAGE = `${IMG}/594c2f15e43d2ec1061abd121c5ba98ffbfd2dd12a863ee445e8fd70141122eb.jpeg`;
export const PHARMACIST_IMAGE = `${IMG}/95a58b0481c854cfa3c72c775f64c9d83713dd268d5b717504df641a3c0e557d.jpeg`;

export const HEALTH_CATEGORIES = [
  {
    name: 'Medical Devices',
    short: 'Devices',
    slug: 'medical-devices',
    tagline: 'Thermometers, BP monitors & oximeters for home check-ups',
    badge: 'Check-ups at home',
    image: `${IMG}/c0eeb803e86d6d1bfc8324a66f50cf9d1b72a3157d5f4fb112161e1d80ad43a3.jpeg`,
    tint: 'bg-health-sky',
    accent: 'text-sky-700',
  },
  {
    name: 'Pain & Cold Relief',
    short: 'Pain & Cold',
    slug: 'pain-cold-relief',
    tagline: 'Over-the-counter comfort for aches, fevers, coughs & sniffles',
    badge: 'Feel-better shelf',
    image: `${IMG}/f257c1340e2a5bbfefe825821ca2823f5767da2771774e835b68b504f6f30975.jpeg`,
    tint: 'bg-health-peach',
    accent: 'text-health-coral',
  },
  {
    name: 'First Aid & Wound Care',
    short: 'First Aid',
    slug: 'first-aid-wound-care',
    tagline: 'Plasters, gauze, antiseptics & ready-to-go first aid kits',
    badge: 'Be prepared',
    image: `${IMG}/4289a3c1d28c5581c65ed95b36be21da647757c629a6a5df8ad027a78e5a3130.jpeg`,
    tint: 'bg-health-mint',
    accent: 'text-health-emerald',
  },
];

export const categoryUrl = (name) => `/products?category=${encodeURIComponent(name)}`;

export const getProductImage = (product, index = 0) => {
  if (product?.images?.length > 0) return product.images[index] || product.images[0];
  return product?.image_url || '';
};
